import { render, staticRenderFns } from "./OrdersLog.vue?vue&type=template&id=0c731ad6&scoped=true&"
import script from "./OrdersLog.vue?vue&type=script&lang=js&"
export * from "./OrdersLog.vue?vue&type=script&lang=js&"
import style0 from "./OrdersLog.vue?vue&type=style&index=0&id=0c731ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c731ad6",
  null
  
)

export default component.exports